// components/Banner.jsx
import React from "react";
import { Box, Typography } from "@mui/material";

const Banner = ({ module, styles, fieldKey }) => {
  return (
    <Box
      sx={{
        backgroundColor: styles.bannerColor || module.color || "grey.300",
        padding: 2,
        borderRadius: 1,
        marginY: 2,
      }}
    >
      {module.children &&
        module.children.map((child, idx) => {
          const childKey = `${fieldKey}-child-${idx}`;
          if (child.type === "header") {
            return (
              <Typography
                key={childKey}
                variant={child.styles?.fontSize || "h5"}
                gutterBottom
                sx={{
                  color: styles?.header?.color || "inherit",
                  fontFamily: styles?.header?.fontFamily || "inherit",
                }}
              >
                {child.text}
              </Typography>
            );
          } else if (child.type === "subheader") {
            return (
              <Typography
                key={childKey}
                variant={child.styles?.fontSize || "h6"}
                gutterBottom
                sx={{
                  color: styles?.subheader?.color || "inherit",
                  fontFamily: styles?.subheader?.fontFamily || "inherit",
                }}
              >
                {child.text}
              </Typography>
            );
          }
          return null;
        })}
    </Box>
  );
};

export default Banner;
